<script setup lang="ts">
defineProps<{
  text: string
  align?: 'left' | 'center' | 'right'
  customClass?: string
}>()
</script>

<template>
  <div
    v-if="text"
    class="flex flex-row"
    :class="[
      align === 'center' ? 'text-center' : '',
      align === 'right' ? 'text-right' : '',
      customClass,
    ]"
  >
    <h3>
      {{ text }}
    </h3>
  </div>
</template>
